import React from "react";
import Header from "./Header";
import ImageCarousel from "./ImageCarousel";
import About from "./About";
import Event from "./Event";
import Footer from "./Footer";

const Home = () => {
  return (
    <div>
      <Header />
      <div className="mt-24">
        <ImageCarousel />
        <About />
        <Event />
        <Footer />
      </div>
    </div>
  );
};

export default Home;
